import type { IDashboardProject } from 'models';

/**
 * Per-row delete confirmation dialog (§3.I — `delete.confirm.tmpl`).
 *
 * `div#popup-content.popup-wrapper.width-small > .popup-content` with the
 * "Delete Project?" heading, the irrecoverable-data warning, a
 * `ul.deleted-items` listing the project name(s), and the two control buttons.
 *
 * INVERTED EMPHASIS (parity 64): Cancel is the highlighted (primary) button and
 * Delete is NOT highlighted (destructive de-emphasis). Confirming destroys the
 * project (DELETE) — see ProjectTable, which decrements counts + refreshes the
 * infobar via RTK Query tag invalidation.
 *
 * Markup matches the Backbone template exactly: `button[name=confirm_delete]`
 * (Delete, `.not-highlighted-btn`) and `button[name=cancel_delete]`
 * (Cancel, `.highlighted-btn`).
 */
interface DeleteProjectConfirmProps {
  /** The project(s) being confirmed for deletion (the row's model). */
  models: IDashboardProject[];
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteProjectConfirm = ({ models, onConfirm, onCancel }: DeleteProjectConfirmProps) => (
  <div id="popup-content" className="popup-wrapper width-small active">
    <div className="popup-content">
      <h2 className="popup-heading">Delete Project?</h2>
      <div className="popup-content-part">
        <p>
          If you choose to Delete, all Project data will be lost and will not be recoverable.
        </p>
        <ul className="deleted-items">
          {models.map((m) => (
            <li key={m.id}>
              <p>{m.name}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="popup-control-buttons">
        <button className="btn not-highlighted-btn" name="confirm_delete" type="button" onClick={onConfirm}>
          Delete
        </button>
        <button
          className="btn highlighted-btn"
          name="cancel_delete"
          type="button"
          autoFocus
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export default DeleteProjectConfirm;
